module.exports = __webpack_public_path__ + "img/white.ae5f6da.svg";